import React from "react";

// Kasta lives on one page today, but uses the same visual navigation model as
// Rozetka. Keeping the list here also makes a future move to dedicated pages
// possible without changing the operator's menu.
const ITEMS = [
    ["account", "Аккаунт"], ["suppliers", "Отправители/цены"], ["pricing", "Цены"], ["catalog", "Выгрузка"],
    ["orders", "Заказы"], ["payments", "Виды оплат"],
    ["status", "Статусы"], ["categories", "Категории"], ["brands", "Бренды"],
    ["journal", "Журнал операций"],
];

export default function KastaTopBar({ activeKey, onSelect }) {
    return <nav aria-label="Разделы Kasta" className="ip-tabbar rzm-tabbar-sticky kasta-topbar">
        {ITEMS.map(([key, label]) => <button key={key} type="button"
            className={activeKey === key ? "ip-tab active" : "ip-tab"} onClick={() => onSelect(key)}>{label}</button>)}
    </nav>;
}
